(ns frontend.rf-app.sub
  (:require
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::tenant
 (fn [{db :db} [_]]
   @session/tenant))

(rf/reg-sub
 ::tenant-schema
 (fn [{db :db} [_]]
   @session/tenant-schema))
